import React from 'react';
import { stats } from '../../mock/mockData';

const Stats = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-teal-600 text-sm font-bold uppercase tracking-widest">Nos résultats</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 tracking-tight">Des chiffres qui parlent d'eux-mêmes</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {stats.map((s, i) => (
            <div key={i} className="group relative bg-gradient-to-br from-teal-50/60 to-white border border-slate-200/70 rounded-2xl p-7 hover:border-teal-300 hover:shadow-xl hover:shadow-teal-500/5 hover:-translate-y-1 transition-all duration-300">
              <div className="text-4xl lg:text-5xl font-bold bg-gradient-to-br from-teal-600 to-emerald-700 bg-clip-text text-transparent mb-2">{s.value}</div>
              <div className="text-sm text-slate-600 font-medium">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
